const borderSpacing = {
  name: "border-spacing",
  path: "/border-spacing",
  title: "border-spacing",
  description: "Utilities for controlling table border spacing.",
  value: {
    'border-spacing': {
      'border-spacing-<number>': '<number>',
      'border-spacing-x-<number>': 'var(--uni-border-spacing-x, <number>) var(--uni-border-spacing-y, 0)',
      'border-spacing-y-<number>': 'var(--uni-border-spacing-x, 0) var(--uni-border-spacing-y, <number>)',
    },
  },
  exampleData: [
    {
      example: {
        code: `<table class="border-separate border-spacing-4 w-full">
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">A</td>
    <td class="border border-color-gray-300 px-4 py-2">B</td>
  </tr>
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">C</td>
    <td class="border border-color-gray-300 px-4 py-2">D</td>
  </tr>
</table>
<table class="border-separate border-spacing-x-4 border-spacing-y-2 w-full mt-6">
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">A</td>
    <td class="border border-color-gray-300 px-4 py-2">B</td>
  </tr>
  <tr>
    <td class="border border-color-gray-300 px-4 py-2">C</td>
    <td class="border border-color-gray-300 px-4 py-2">D</td>
  </tr>
</table>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">border-spacing-*</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">border-spacing-x-*</code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">border-spacing-y-*</code> to control cell spacing in tables.
      </p>
      <div class="flex flex-col">
        <p class="mb-2 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">border-spacing-2</p>
        <table class="border-separate border-spacing-2 w-full">
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">A</td>
            <td class="border border-color-gray-300 px-4 py-2">B</td>
          </tr>
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">C</td>
            <td class="border border-color-gray-300 px-4 py-2">D</td>
          </tr>
        </table>
        <p class="mb-2 mt-8 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">border-spacing-x-4 + border-spacing-y-2</p>
        <table class="border-separate border-spacing-x-4 border-spacing-y-2 w-full">
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">A</td>
            <td class="border border-color-gray-300 px-4 py-2">B</td>
          </tr>
          <tr>
            <td class="border border-color-gray-300 px-4 py-2">C</td>
            <td class="border border-color-gray-300 px-4 py-2">D</td>
          </tr>
        </table>
      </div>
      `
    }
  ]
};

export default borderSpacing;
<div className="sr-only border-spacing-2 border-spacing-x-4 border-spacing-y-2 border-separate"></div>